/*
  hide-fitment-wall.js
  Strips ONLY the long Polaris vehicle-fitment list (the "wall of text") from
  the product DESCRIPTION on the RZR XP wheel-bearing pages. Everything else in
  the description is kept: the "Bearing Features" list above it, and below it the
  "Complete vehicle fitment here" link, Details, the "Replaces:" OEM part numbers,
  bearing dimensions, install link, fitment note, and the marketing "Description".

  The interactive Fitment Check (above Add to Cart) replaces the removed list.

  Loaded ONLY from snippets/bearing-fitment.liquid, which self-gates to the RZR XP
  wheel-bearing products (single + 4-pack), so this never runs elsewhere.

  Boundaries (all matched against the description's DIRECT children):
    START = the "RZR XP Models" heading; if a short "Fitment" lead-in heading (or
            empty spacer) sits directly above it, that's pulled in too.
    END   = the first block after the list that is clearly post-list content
            ("Complete vehicle fitment here" / Details / Replaces / Dimensions /
            Installation / Description). Removal stops BEFORE it.
  Fail-safe: if the would-be removal range contains any keep-content, or the START
  marker isn't a direct child, nothing is removed and the page is left as-is.

  See docs/bearing-fitment.md.
*/
(function () {
  'use strict';

  var DESC_SELECTORS = '.product__description, .product-single__description';
  var START_MARKER = 'rzr xp models';                       // list begins here
  var LEADIN = /(fitment|compatible|application|fits the following)/i; // heading above the list
  // First non-vehicle block after the list — removal stops before the earliest of these.
  var END = /(complete vehicle fitment|^details\b|^replaces\b|bearing dimensions|installation instructions|important fitment note|^description\b)/i;
  // If any of these appear inside the removal range, abort (structure unexpected).
  var KEEP_GUARD = /(replaces|bearing dimensions|installation instructions|^description\b|part number|interchange)/i;

  function norm(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function trimDescription(desc) {
    if (!desc || desc.__fitmentTrimmed) return false;
    var kids = Array.prototype.slice.call(desc.children);
    if (!kids.length) return false;

    // START: first direct child whose text begins with the list marker.
    var rzrIdx = -1;
    for (var i = 0; i < kids.length; i++) {
      if (norm(kids[i]).toLowerCase().indexOf(START_MARKER) === 0) { rzrIdx = i; break; }
    }
    if (rzrIdx === -1) return false;

    // Pull in a lead-in heading / empty spacer directly above the marker.
    var startIdx = rzrIdx;
    if (rzrIdx > 0) {
      var prev = norm(kids[rzrIdx - 1]);
      if (!prev || (prev.length < 60 && LEADIN.test(prev))) startIdx = rzrIdx - 1;
    }

    // END: first post-list block after the marker.
    var endIdx = kids.length;
    for (var j = rzrIdx + 1; j < kids.length; j++) {
      if (END.test(norm(kids[j]))) { endIdx = j; break; }
    }

    // Fail-safe: never remove keep-content.
    for (var g = startIdx; g < endIdx; g++) {
      if (KEEP_GUARD.test(norm(kids[g]))) return false;
    }

    // Remove the vehicle-list block (bottom-up).
    for (var k = endIdx - 1; k >= startIdx; k--) {
      if (kids[k] && kids[k].parentNode) kids[k].parentNode.removeChild(kids[k]);
    }
    desc.__fitmentTrimmed = true;
    return true;
  }

  function run() {
    var done = false;
    var nodes = document.querySelectorAll(DESC_SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      if (trimDescription(nodes[i])) done = true;
    }
    return done;
  }

  function start() {
    if (run()) return;
    // Catch descriptions injected late (section re-render, quick-view, etc.).
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (run() || tries >= 20) clearInterval(iv); // give up after ~6s
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
